import { Products } from '@site-mate/sitemate-global-shared';
import { create } from 'zustand';

interface WorkspaceSwitcherStore {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;

  isUpgradePlanOpen: boolean;
  upgradePlanProduct: Products;
  setIsUpgradePlanOpen: (isUpgradePlanOpen: boolean, product?: Products) => void;
}

export const useWorkspaceSwitcherStore = create<WorkspaceSwitcherStore>((set) => ({
  isOpen: false,
  setIsOpen: (isOpen: boolean) => set({ isOpen }),

  isUpgradePlanOpen: false,
  upgradePlanProduct: Products.Gearbelt,
  setIsUpgradePlanOpen: (isUpgradePlanOpen: boolean, product?: Products) => set({ isUpgradePlanOpen, ...(product && { upgradePlanProduct: product }) }),
}));
